var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      staticClass: "wk-table-items",
      staticStyle: { width: "100%" },
      attrs: { data: _vm.fieldFrom, "row-key": Date.now().toString() },
    },
    [
      _c("el-table-column", {
        attrs: { label: "序号", width: "50" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row, column, $index }) {
              return [_vm._v("\n      " + _vm._s($index + 1) + "\n    ")]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _vm._l(_vm.fieldList, function (item, index) {
        return _vm.getShowValue(item)
          ? _c("el-table-column", {
              key: index,
              attrs: {
                prop: item.field,
                "min-width": _vm.getMinWidth(item.formType),
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        item.isNull == 1
                          ? _c("span", { staticClass: "red" }, [_vm._v("*")])
                          : _vm._e(),
                        _vm._v(_vm._s(item.name) + "\n    "),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function ({ row, column, $index }) {
                      return [
                        _c("wk-form-item", {
                          attrs: {
                            "prop-prefix": `${
                              _vm.propPrefix || ""
                            }[${$index}].`,
                            item: _vm.fieldList[index],
                            index: $index,
                            "field-from": _vm.fieldFrom[$index],
                            disabled: _vm.disabled,
                          },
                          on: { change: _vm.fieldChange },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ data, index }) {
                                  return [
                                    _vm._t("default", null, {
                                      data: data,
                                      index: $index,
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          : _vm._e()
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { resizable: false, label: "操作", width: "60" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row, column, $index }) {
              return [
                _c("el-button", {
                  attrs: { icon: "wk wk-icon-bin", type: "text" },
                  on: {
                    click: function ($event) {
                      return _vm.deleteClick($index)
                    },
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }